// Modules
import { buildRoutesByDevice } from '@/modules/spotlight/router';

// Views
import ErrorView from '@/views/shared/ErrorPageV2.vue';

import MobileHome from '@/views/shared/DHSV2.vue';
import TradeWrapper from '@/views/trade-in/TradeWrapper.vue';
import CreditWrapper from '@/views/credit/CreditWrapper.vue';
import InsuranceWrapper from '@/views/insurance/InsuranceWrapper.vue';
import ReviewWrapper from '@/views/reviews/ReviewWrapper.vue';
import TestDriveWrapper from '@/components/test-drive/TestDriveWrapper.vue';
import ECommerceV2Wrapper from '@/components/e-commerce-v2/layout/EcommerceV2Wrapper.vue';
import SpinWrapper from '@/views/spin/layout/SpinWrapper.vue';
import SpotlightWrapper from '@/modules/spotlight/layout/SpotlightWrapper.vue';
import BuildAndPriceWrapper from '@/components/build-and-price/layout/BuildAndPriceWrapper.vue';

// Routes
import acquireRoute from '@/router/embed/acquire';
import buildAndPriceRoute from '@/router/mobile/build-and-price';
import spinRoute from '@/router/mobile/spin/index';
import eCommerceV2Route from '@/router/mobile/e-commerce-v2/index';
import testDriveRoute from '@/router/embed/test-drive/index';
import reviewRoute from '@/router/embed/reviews/index';
import insuranceRoute from '@/router/embed/insurance/index';
import creditRoute from '@/router/embed/credit/index';
import tradeInRoute from '@/router/embed/trade-in/index';
import SelectDealership from '@/views/shared/SelectDealership.vue';

export default [
  {
    path: '',
    redirect: { name: 'home-embed' },
  },
  {
    path: ':product?/select-dealership',
    name: 'select-dealership-embed',
    component: SelectDealership,
  },
  {
    path: 'home',
    name: 'home-embed',
    component: MobileHome,
    meta: { appBackground: true },
  },
  {
    path: 'tradein',
    component: TradeWrapper,
    children: tradeInRoute,
  },
  {
    path: 'acquire',
    component: TradeWrapper,
    children: acquireRoute,
  },
  {
    path: 'credit',
    component: CreditWrapper,
    children: creditRoute,
  },
  {
    path: 'insurance',
    component: InsuranceWrapper,
    children: insuranceRoute,
  },
  {
    path: 'reviews',
    component: ReviewWrapper,
    children: reviewRoute,
  },
  {
    path: 'test-drive',
    component: TestDriveWrapper,
    children: testDriveRoute,
  },
  {
    path: 'spotlight',
    component: SpotlightWrapper,
    children: buildRoutesByDevice('embed'),
  },
  {
    path: 'e-commerce-v2',
    component: ECommerceV2Wrapper,
    children: eCommerceV2Route,
  },
  {
    path: 'spin',
    component: SpinWrapper,
    children: spinRoute,
  },
  {
    path: 'build-and-price',
    component: BuildAndPriceWrapper,
    children: buildAndPriceRoute,
  },
  {
    path: 'lead-expired',
    name: 'lead-expired-embed',
    component: ErrorView,
    meta: {
      headerIcon: false,
      navInfo: false,
      hasNext: false,
      errorPayload: {
        errorType: 'expired',
      },
    },
  },
];
